import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetConfigNames,
  CreateConfigName,
  UpdateConfigName,
  DeleteConfigName } from "../Api";
import { unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const configNameQueryKeys = {
  list: () => ["configNames"] as const,
};

export const useConfigNamesQuery = () => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    queryKey: configNameQueryKeys.list(),
    queryFn: async () => unwrapApiResponse(await GetConfigNames()),
  });
};

export const useCreateConfigNameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateConfigName>[0]) =>
      CreateConfigName(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: ["configNames"] });
      }
    },
  });
};

export const useUpdateConfigNameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateConfigName>[0]) =>
      UpdateConfigName(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: ["configNames"] });
      }
    },
  });
};

export const useDeleteConfigNameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => DeleteConfigName(id),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({ queryKey: ["configNames"] });
      }
    },
  });
};
